import ENDPOINTS from '../../../consts/endpoints';
import DADOS_SIM from '../../../consts/consts';
import api from '../../../services/api';
import TIPOS_COTACAO from '../../../consts/tipos-cotacao';
import { extractErrorFromResponse } from '../../../assets/js/function-utils';

const cotacaoValues = DADOS_SIM.DADOS_COTACAO;
const tiposCotacao = TIPOS_COTACAO;

/**
 * @Summary Função responsável por buscar os tipos de cotação
 */
export async function fetchData(chaveMobSeg) {
    try {
        const response = await api.get(ENDPOINTS.TIPO_COTACAO(chaveMobSeg));
        const resultado = response.data.resultado;
        const options = resultado.map((el) => ({
            key: el[cotacaoValues.ID_TIPO_COTACAO],
            text: el[cotacaoValues.TIPO_COTACAO],
            value: el[cotacaoValues.TIPO_COTACAO]
        }));
        return { options, error: false, loading: false };
    } catch (err) {
        return { options: [], error: true, loading: false, msgError: extractErrorFromResponse(err) };
    }
}

/**
 * @Summary Função responsável por validar o código de acesso
 */
export async function validarCodigoDeAcesso(values) {
    try {
        const response = await api.get(ENDPOINTS.CODIGO_ACESSO(values[cotacaoValues.CODIGO_ACESSO]));
        if (response.data.resultado) return true;
    } catch (err) {
        const errorMessage = extractErrorFromResponse(err);
        return Promise.reject({ [cotacaoValues.CODIGO_ACESSO]: errorMessage });
    }
}

/**
 * @Summary Função responsável por validar o Form no Submit
 */
let camposErro = [];
let objError = {};
let error = false;
export function validarCampos(values) {
    camposErro = [];
    objError = {};
    error = false;

    validarTipoCotacao(values);
    validarCodigoAcesso(values);

    return { camposErro, objError, error };
}

function validarTipoCotacao(values) {
    verifyObjectAndSetError(
        !values[cotacaoValues.ID_TIPO_COTACAO],
        cotacaoValues.ID_TIPO_COTACAO,
        'Tipo de simulação',
        'O Campo é obrigatório'
    );
}

function validarCodigoAcesso(values) {
    verifyObjectAndSetError(
        values[cotacaoValues.ID_TIPO_COTACAO] === tiposCotacao.NEGOC_ESPEC && !values[cotacaoValues.CODIGO_ACESSO],
        cotacaoValues.CODIGO_ACESSO,
        'Código de Acesso',
        'O Campo é obrigatório'
    );
}

function verifyObjectAndSetError(condition, field, label, message) {
    if (condition) {
        camposErro.push(label);
        objError = {
            ...objError,
            [field]: message
        };
        error = true;
        return true;
    }
    return false;
}
